// Stop a stray file drop from navigating the whole tab.
//
// A browser's DEFAULT action for a file dropped anywhere it wasn't told to
// expect one is to navigate the tab to display that file. There's no error, no
// exception, nothing in any log — the app is simply gone, along with whatever
// the creator had typed. From their side it is indistinguishable from "the
// page randomly refreshed", which is exactly how it kept getting reported.
//
// That default only backs off when BOTH dragover and drop have
// preventDefault() called somewhere in their bubble path.
//
// UploadItem already does this for its own lifetime, but 22 other screens
// accept files (PageBuilder, the storefront Inspector, Poster Studio,
// CreatorProfilePage, EventEditor, support tickets, the admin tools...) and
// none of them were covered. Missing a drop target by a few pixels is easy,
// and on every one of those screens it cost the creator their work.
//
// Deliberately narrow: only drags that actually carry FILES are cancelled.
// Dragging selected text into a textarea is a normal editing gesture and must
// keep working, so those are left alone entirely.

function dragCarriesFiles(e) {
  const types = e?.dataTransfer?.types;
  if (!types) return false;
  // `types` is a DOMStringList on some browsers and a plain array on others —
  // both expose indexOf/contains via Array.prototype.includes.call, but
  // Array.from is clearer and safe for both.
  try {
    return Array.from(types).includes('Files');
  } catch (_) {
    return false;
  }
}

export function installFileDropNavigationGuard(target = window) {
  if (!target || typeof target.addEventListener !== 'function') return () => {};

  const stopNavigation = (e) => {
    if (dragCarriesFiles(e)) e.preventDefault();
  };

  target.addEventListener('dragover', stopNavigation);
  target.addEventListener('drop', stopNavigation);

  return () => {
    target.removeEventListener('dragover', stopNavigation);
    target.removeEventListener('drop', stopNavigation);
  };
}
